import React from 'react';
import { Box, Paper, Typography, Button, IconButton, useTheme } from '@mui/material';
import { Close } from '@mui/icons-material';
import { TooltipRenderProps } from 'react-joyride';
import '../../cat-theme.css';

const MichiTooltip: React.FC<TooltipRenderProps> = ({
    continuous,
    index,
    step,
    backProps,
    closeProps,
    primaryProps,
    tooltipProps,
    isLastStep,
}) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';
    return (
        <Box
            {...tooltipProps}
            sx={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                maxWidth: 400,
                zIndex: 9999,
                '&:focus': { outline: 'none' }
            }}
        >
            {/* Cat Avatar placed on top/side */}
            <Box
                sx={{
                    fontSize: '60px',
                    mb: -2,
                    zIndex: 2,
                    filter: `drop-shadow(0 4px 8px ${isDark ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.2)'})`,
                    animation: 'float-cat 3s ease-in-out infinite'
                }}
            >
                😺
            </Box>

            {/* Speech Bubble */}
            <Paper
                elevation={4}
                sx={{
                    p: 3,
                    pt: 4,
                    borderRadius: '24px',
                    background: isDark ? 'rgba(30,30,30,0.98)' : 'rgba(255, 255, 255, 0.98)',
                    backdropFilter: 'blur(10px)',
                    border: '2px solid rgba(255, 107, 157, 0.3)',
                    boxShadow: isDark ? '0 8px 32px rgba(255,255,255,0.1)' : '0 8px 32px rgba(0,0,0,0.1)',
                    position: 'relative',
                    maxWidth: '100%',
                    textAlign: 'center'
                }}
            >
                <IconButton
                    {...closeProps}
                    size="small"
                    sx={{
                        position: 'absolute',
                        top: 10,
                        right: 10,
                        color: 'text.secondary',
                        '&:hover': { color: 'error.main' }
                    }}
                >
                    <Close fontSize="small" />
                </IconButton>

                <Typography variant="h6" sx={{ color: '#FF6B9D', mb: 1, fontWeight: 'bold' }}>
                    {step.title}
                </Typography>

                <Typography variant="body1" sx={{ color: '#5D4037', mb: 3 }}>
                    {step.content}
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, mt: 1 }}>
                    {index > 0 && (
                        <Button
                            {...backProps}
                            variant="outlined"
                            size="small"
                            sx={{
                                borderRadius: '20px',
                                color: '#9B59B6',
                                borderColor: '#9B59B6'
                            }}
                        >
                            Anterior
                        </Button>
                    )}

                    <Button
                        {...primaryProps}
                        variant="contained"
                        size="small"
                        sx={{
                            borderRadius: '20px',
                            background: 'linear-gradient(45deg, #FF6B9D 30%, #FF8E53 90%)',
                            color: 'white',
                            px: 3,
                            ml: 'auto'
                        }}
                    >
                        {isLastStep ? '¡Entendido!' : 'Siguiente'}
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
};

export default MichiTooltip;
